import React from 'react';
import Button from '@xanadu/ui-shared/components/widgets/Button';
import PropTypes from 'prop-types';

import DriverLicenceIcon from '../../../../../images/icons/icon_drivers_license.svg';
import PassportIcon from '../../../../../images/icons/icon_passport.svg';

import styles from './GraiDualVerification.module.scss';

const GraiDualVerification = ({ displayModal }) => {

  const handleExternalDocUploader = (journeyType) => {
    displayModal({
      show: true,
      section: 'upload-documents',
      data: {
        journeyType
      }
    });
  };

  return (
    <div className={styles.main}>
      <div className={styles.mainTitle}>Account Verification Required</div>
      <div>
        <span>
          Due to regulatory requirements in Ireland,
          you must complete verification before your account can be opened.
          <br />
          <br />
          Select from one of the options below:
        </span>
      </div>
      <div className={styles.containerActions}>
        <Button
          onClick={() => handleExternalDocUploader('DRIVER_LICENSE')}
          className={styles.verificationButton}
          sizeType="wider"
        >
          <div className={styles.licenceContainer}>
            <span className={styles.headerVerification}>Fast Verification</span>
            <DriverLicenceIcon className={styles.icon} />
            <span className={styles.title}>Drivers Licence</span>
            <span className={styles.body}>Only one document required</span>
          </div>
        </Button>
        <Button
          onClick={() => handleExternalDocUploader('PASSPORT')}
          className={styles.verificationButton}
          sizeType="wider"
        >
          <div className={styles.passportContainer}>
            <PassportIcon className={styles.icon} />
            <span className={styles.title}>Passport + 2x Proof of Address</span>
            <div>
              <span className={styles.body}>Proof of address includes:</span>
              <ul className={styles.list}>
                <li>Utility bill</li>
                <li>Insurance policy</li>
                <li>Government Issued Tax Document</li>
              </ul>
            </div>
          </div>
        </Button>
      </div>
    </div>
  );
};

GraiDualVerification.propTypes = {
  displayModal: PropTypes.func.isRequired,
};

export default GraiDualVerification;